import type { FaireProductEntity } from "../../entity_types/product";

export const p_e26jdu74zp: FaireProductEntity = {
  token: "p_e26jdu74zp",
  type: "product",
  name: "Sticky Notes Pad - Bible Verse - 300 Sheets",
  brandToken: "b_5604c64c",
  brandName: "Taylor Elliott Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/667d46943b52aa21cdfdd88663654b33ea2e31e20a111578373abd1922c6d8d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be185303aea2e754e3c46b3ee536c0817b1ba0c4aafd30ba0e07dcd7b71fe4ba.jpeg",
  ],
  priceDollars: 5,
  description:
    'This colorful pad includes the bible verse from 1 Corinthians 10:31 on top of every note. Pair it a pen and make it a gift set! Our sticky notes are perfect for desk accessories, stationery, gift bundles and more!\n\nDetails\n* Size: 3.5" x 3.5"\n* 300 sheets\n* Imprinted with "Whatever you do, do it all for the glory of God." 1 Corinthians 10:31\n* Sticky adhesive backing\n* Shrink-wrap packaging\n* Imported',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:40.819Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
